import Navbar from "../components/Navbar";
import Footer from "../components/footer";
import Offer from "../components/offer";
import "../css/details.css";
import { Button, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./details.css";

const Details = () => {
  const navigate = useNavigate();

  const [productDetails, setProductData] = useState();
  const [distributerData, setDistributerData] = useState([]);
  const { productId } = useParams();

  const [offers, setOffers] = useState([]);
  useEffect(() => {
    getOffers();
    window.scrollTo(0, 0);
  }, []);

  // Fetch offers from API
  const getOffers = async () => {
    try {
      const res = await axios.get(`http://api.meddaily.in/getoffer`);
      if (res.status === 200) {
        setOffers(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // Fetch product and distributor details from API
    axios
      .post(
        "http://api.meddaily.in/product_details",
        {
          id: productId,
        },
        { headers: { token: sessionStorage.getItem("token") } }
      )
      .then((res) => {
        setProductData(res.data.product);
        setDistributerData(res.data.distributor);
        // console.log("res", res);
      })
      .catch((error) =>
        console.error("Error fetching category product data:", error)
      );
  }, []);

  const addToCart = () => {
    const carts = [];

    distributerData.forEach((distributor, index) => {
      debugger;
      const data = {
        product_id: productId,
        distributor_id: distributor.distributorId,
        quantity: cartQuantities[index] || 0,
      };
      console.log("data", data);
      carts.push(
        axios.post("http://api.meddaily.in/add_to_cart", data, {
          headers: { token: sessionStorage.getItem("token") },
        })
      );
    });
    axios
      .all(carts)
      .then((responses) => {
        console.log("Add to cart responses:", responses);

        navigate("/ordersummary", {
          state: {
            applicableTax: productDetails.applicable_tax,
            cartQuantities: responses.map((response) => response.data),
          },
        });
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  };

  // const [cartQuantities, setCartQuantities] = useState([]); // Array of quantities for each distributor

  const [cartQuantities, setCartQuantities] = useState(
    Array(distributerData.length).fill(0)
  );

  // const incrementQuantity = (index) => {
  //   const updatedQuantities = [...cartQuantities];
  //   updatedQuantities[index] = (updatedQuantities[index] || 0) + 1;
  //   setCartQuantities(updatedQuantities);
  // };

  // const decrementQuantity = (index) => {
  //   if (cartQuantities[index] > 0) {
  //     const updatedQuantities = [...cartQuantities];
  //     updatedQuantities[index] -= 1;
  //     setCartQuantities(updatedQuantities);
  //   }
  // };

  // const handleQuantityChange = (index, e) => {
  //   const updatedQuantities = [...cartQuantities];
  //   updatedQuantities[index] = parseInt(e.target.value);
  //   setCartQuantities(updatedQuantities);
  // };

  const incrementQuantity = (index) => {
    const updatedQuantities = [...cartQuantities];
    updatedQuantities[index] = (updatedQuantities[index] || 0) + 1;
    setCartQuantities(updatedQuantities);
  };

  const decrementQuantity = (index) => {
    if (cartQuantities[index] > 0) {
      const updatedQuantities = [...cartQuantities];
      updatedQuantities[index] -= 1;
      setCartQuantities(updatedQuantities);
    }
  };

  const handleQuantityChange = (index, e) => {
    const updatedQuantities = [...cartQuantities];
    updatedQuantities[index] = parseInt(e.target.value);
    setCartQuantities(updatedQuantities);
  };

  console.log("products", productDetails);
  console.log("distributor", distributerData);

  return (
    <>
      <Navbar />
      <div>
        <div className="medicine-details">
          {productDetails && (
            <div>
              <Typography variant="h4">{productDetails.name}</Typography>
              <div className="branded">
                <Typography fontSize={14}>Branded</Typography>
              </div>
              <Typography mt={3} mb={2} variant="h6" color="#818181">
                Best Price*{" "}
                <span style={{ color: "#960018" }}>
                  ₹ {productDetails.price.upDatePrice}
                </span>
              </Typography>
              <ul>
                <li>Mkt: {productDetails.subname}</li>
                <li>
                  Delivery charges if applicable will be applied at checkout
                </li>
              </ul>
            </div>
          )}

          <div className="offers-div">
            <Typography variant="h6" mt={2} color="#960018">
              Offers Available
            </Typography>
            {offers &&
              offers.length > 0 &&
              offers.map((item, ind) => {
                return <Offer item={item} ind={ind} />;
              })}
          </div>
        </div>

        {productDetails && (
          <div className="description">
            <Typography variant="h5" color="#960018">
              Description
            </Typography>
            <Typography>{productDetails.description}</Typography>
          </div>
        )}

        <div class="available-distributor">
          <Typography variant="h6" color="#960018" ml={4} mb={3}>
            Available Distributors
          </Typography>

          {/* {distributerData.map((item, index) => (
            <div className="dist-name" key={index}>
              <Typography>Name: {item.distributorName}</Typography>
              <Typography>Price: {item.price}</Typography>
              <Typography>Stock: {item.stock}</Typography>

              <div className="count">
                <Button onClick={() => decrementQuantity(index)}>
                  <RemoveIcon />
                </Button>

                <input
                  className="quantity-inp"
                  placeholder="10"
                  value={cartQuantities[index] || 0}
                  onChange={(e) => handleQuantityChange(index, e)}
                ></input>

                <Button
                  onClick={() => incrementQuantity(index)}
                  disabled={cartQuantities[index] >= item.stock}
                >
                  <AddIcon />
                </Button>
              </div>
            </div>
          ))} */}
          {/* <table style={{ width: "100%" }} className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Quantity</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ width: "100%" }}>
              {distributerData.map((item, index) => (
                <tr key={index}>
                  <td style={{ position: "relative", left: "120px" }}>
                    {item.distributorName}
                  </td>
                  <td style={{ position: "relative", left: "60px" }}>
                    {item.price}
                  </td>
                  <td style={{ position: "relative", left: "75px" }}>
                    {item.stock}
                  </td>
                  <td style={{ position: "relative", left: "205px" }}>
                    <div className="count">
                      <Button onClick={() => decrementQuantity(index)}>
                        <RemoveIcon />
                      </Button>
                      <input
                        className="quantity-inp"
                        placeholder="10"
                        value={cartQuantities[index] || 0}
                        onChange={(e) => handleQuantityChange(index, e)}
                      ></input>
                      <Button
                        onClick={() => incrementQuantity(index)}
                        disabled={cartQuantities[index] >= item.stock}
                      >
                        <AddIcon />
                      </Button>
                    </div>
                  </td>
                  <td style={{ position: "relative", left: "85px" }}>
                    <Button onClick={() => addToCart(item)}>Add to Cart</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> */}
          <table className="table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {distributerData.map((item, index) => {
                const isSameDistributor =
                  item.distributorId === distributerData[0].distributorId;

                return (
                  <tr key={index}>
                    <td data-label="Name">{item.distributorName}</td>
                    <td data-label="Price">{item.price}</td>
                    <td data-label="Stock">{item.stock}</td>
                    <td data-label="inp">
                      {/* <div className="count" > */}
                      <Button
                        onClick={() => decrementQuantity(index)}
                        disabled={
                          !isSameDistributor || cartQuantities[index] <= 0
                        }
                      >
                        <RemoveIcon />
                      </Button>
                      <input
                        className="quantity-inp"
                        placeholder="10"
                        value={cartQuantities[index] || 0}
                        onChange={(e) => handleQuantityChange(index, e)}
                      ></input>
                      <Button
                        onClick={() => incrementQuantity(index)}
                        // disabled={cartQuantities[index] >= item.stock}
                        disabled={
                          !isSameDistributor ||
                          cartQuantities[index] >= item.stock
                        }
                      >
                        <AddIcon />
                      </Button>
                      {/* </div> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <Button
            onClick={addToCart}
            style={{ position: "relative", left: "76%", marginTop: "10px" }}
          >
            Add TO Cart
          </Button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Details;
